import { Pipe, PipeTransform } from '@angular/core';
import { DecimalPipe } from '@angular/common';

@Pipe({ name: 'bnCurrencyPipe' })
export class BnCurrencyPipe implements PipeTransform {
  constructor(private number: DecimalPipe) {}

  transform(value: string | undefined | null, currency: string, empty = '--'): string {
    return value === undefined || value === null || value === '' || +value === -1
      ? empty
      : `${currency}$ ${this.number.transform(value, '1.2-2')}`;
  }
}
